import template from "./custom-domain-settings.html";

const CustomDomainSettingsComponent = {
  template: template,
  controller: class CustomDomainSettingsComponent {
    /* @ngInject */
    constructor($rootScope, OrganizationService, SweetAlertService, $timeout) {
      this.$rootScope = $rootScope;
      this.OrganizationService = OrganizationService;
      this.SweetAlertService = SweetAlertService;
      this.$timeout = $timeout;
    }

    $onInit() {
      this.defaultDomainUrl = process.env.PROPOSAL_URL;
      this.loading = false;
      this.verifying = false;
      this.customDomainUrl = null;
      this.editableOrganization = angular.copy(this.$rootScope.organization);
      this.verificationError = false;
    }

    async setDefaultCustomDomain() {
      if (await this.SweetAlertService.confirmationRequestDefaultDomain()) {
        this.loading = true;
        this.editableOrganization.settings.customDomain = {};
        this.editableOrganization.settings.customDomain.url = this.defaultDomainUrl;
        await this.OrganizationService.updateOrganization(this.editableOrganization);
        await this.SweetAlertService.successfullyRequestedDefaultDomain();
        this.customDomainUrl = null;
        this.customDomainForm.$setPristine();
        this.loading = false;
        this.$rootScope.$applyAsync();
      }
    }

    async changeCustomDomain() {
      this.loading = true;
      if (!this.editableOrganization.settings.customDomain) this.editableOrganization.settings.customDomain = {};
      if (!this.editableOrganization.settings.customDomain.url) await this.setCustomDomainAndUpdate();
      else if (await this.SweetAlertService.confirmationRequestCustomDomain()) await this.setCustomDomainAndUpdate();
      this.verificationError = false;
      this.loading = false;
    }

    async setCustomDomainAndUpdate() {
      this.editableOrganization.settings.customDomain.url = this.customDomainUrl;
      await this.OrganizationService.updateOrganization(this.editableOrganization);
      this.customDomainUrl = null;
      this.verificationError = false;
      this.customDomainForm.$setPristine();
      this.$rootScope.$applyAsync();
    }

    async verifyCustomDomain() {
      this.verifying = true;
      await this.OrganizationService.verifyCustomDomain();
      this.editableOrganization = angular.copy(this.$rootScope.organization);
      if (this.$rootScope.organization.isVerifiedCustomDomain()) this.verificationError = false;
      else this.verificationError = true;
      this.$timeout(() => {
        this.verifying = false;
        this.$rootScope.$applyAsync();
      }, 1000);
    }
  },
};

export default CustomDomainSettingsComponent;
